<template>
  <div class="app-container">
    <el-card class="form-container2" shadow="never">
      <el-tree
        :data="menuTreeList"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps">
      </el-tree>
      <div style="margin-top: 20px" align="center">
        <el-button type="primary" @click="handleSave()">保存</el-button>
        <el-button @click="handleClear()">清空</el-button>
      </div>

    </el-card>
  </div>

</template>

<script>


  import {fetchTreeList} from "../../../api/umsmenu";
  import {allocMenu, listMenuByRole} from "../../../api/umsrole";
  import {allocAdminMenu, qlAdminMenu, qlStoreMenuTree} from "../../../api/storeFront";
  import globaldata from "../../../utils/globaldata";

  export default {
    name: "allocMenuToAdmin",
    data() {
      return {
        menuTreeList: [], //门店可以看的所有菜单权限
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        adminId:null
      };
    },
    created() {
      this.adminId = this.$route.query.adminId;
      this.treeList();
      this.getAdminMenu(this.adminId);
    },
    methods: {
      treeList() {
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        qlStoreMenuTree(param).then(response => {
          this.menuTreeList = response.data;
        });
      },
      getAdminMenu(adminId){
        let param = {
          adminId:adminId
        }
        qlAdminMenu(param).then(response=>{
          let menuList = response.data;
          let checkedMenuIds=[];
          if(menuList!=null&&menuList.length>0){
            for(let i=0;i<menuList.length;i++){
              let menu = menuList[i];
              if(menu.parentId!==0){
                checkedMenuIds.push(menu.id);
              }
            }
          }
          this.$refs.tree.setCheckedKeys(checkedMenuIds);
        });
      },
      handleSave() {
        let checkedNodes = this.$refs.tree.getCheckedNodes();
        let checkedMenuIds=new Set();
        if(checkedNodes!=null&&checkedNodes.length>0){
          for(let i=0;i<checkedNodes.length;i++){
            let checkedNode = checkedNodes[i];
            checkedMenuIds.add(checkedNode.id);
            if(checkedNode.parentId!==0){
              checkedMenuIds.add(checkedNode.parentId);
            }
          }
        }
        this.$confirm('是否分配菜单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          let params = new URLSearchParams();
          params.append("adminId",this.adminId);
          params.append("menuIds",Array.from(checkedMenuIds));
          allocAdminMenu(params).then(response => {
            this.$message({
              message: '分配成功',
              type: 'success',
              duration: 1000
            });
            this.$router.back();
          })
        })
      },
      handleClear() {
        this.$refs.tree.setCheckedKeys([]);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ums/admin/allocMenuToAdmin.vue